var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegenerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1 36.8c-2.5-1.5-5.8.3-5.8 3.3v26.5c0 3 3.2 4.8 5.8 3.3L66 56.7c2.4-1.5 2.4-5 0-6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8 30.2c-1.6-2.5-4.9-3.4-7.4-1.8-2.6 1.6-3.4 4.9-1.8 7.6 3.6 5.9 5.4 13.1 4.7 20.7-1.6 16.1-14.8 28.9-31 30C32.7 88 16.4 72.4 16.6 53c.2-18 14.9-32.8 32.8-33.1 1 0 1.9 0 2.9.1v4.2c0 1.7 1.9 2.7 3.3 1.8l15.6-9.7c1.3-.8 1.3-2.8 0-3.6L55.5 2.8c-1.4-.9-3.3.1-3.3 1.8V9H50C24.5 9 3.9 30.7 5.9 56.6 7.5 78.3 25 95.8 46.6 97.4c25.9 1.9 47.7-18.6 47.7-44.1 0-8.5-2.4-16.4-6.5-23.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerate);
export default __webpack_public_path__ + "static/media/regenerate.797020c31ffc80788dcbe8e91dad5a03.svg";
export { ForwardRef as ReactComponent };